import { getApiUrl, API_ENDPOINTS } from '../environments';
import axios from 'axios';

export const login = async (): Promise<string> => {
    try {
        const response = await axios.post<string>(`${getApiUrl()}${API_ENDPOINTS.LOGIN}`, {
            Username: 'RocketBotAPI',
            Password: 'R0cketBot.24'
        });

        // La respuesta es directamente el token
        const token = response.data;
        return token;
    } catch (error: any) {
        console.error('Error en login:', error);
        throw {
            message: 'Error de autenticación',
            data: error.response?.data || error.message || 'No se pudo iniciar sesión'
        };
    }
};

export const getStoredToken = async(): Promise<string | null> => {
    return await login();
};